/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/templates/page.press.js":
/*!*********************************************!*\
  !*** ./src/scripts/templates/page.press.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-sections */ \"./node_modules/@shopify/theme-sections/theme-sections.js\");\n/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! jquery */ \"jquery\");\n/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! slick-carousel/slick/slick.min.js */ \"./node_modules/slick-carousel/slick/slick.min.js\");\n/* harmony import */ var slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_2__);\n/* harmony import */ var _components_modal_video__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../components/modal-video */ \"./src/scripts/components/modal-video.js\");\n\r\n\r\n\r\n\r\n\r\n\r\nfeaturedArticlesCarousel();\r\nmobileVideoCarousel();\r\nloadMoreVideos();\r\n\r\nawardsCarousel();\r\narticlesCarousel();\r\n\r\njquery__WEBPACK_IMPORTED_MODULE_1___default()( window ).resize(function() {\r\n  loadMoreVideos();  \r\n  mobileVideoCarousel();\r\n});\r\n\r\nfunction featuredArticlesCarousel() {\r\n  var featuredArticles = jquery__WEBPACK_IMPORTED_MODULE_1___default()('.js-press__featured-carousel');\r\n  var header = featuredArticles.siblings('.press__title-header');\r\n  featuredArticles.slick({\r\n    infinite: false,\r\n    speed: 500,\r\n    slidesToShow: 3,\r\n    slidesToScroll: 1,\r\n    appendArrows: header,\r\n    responsive: [\r\n      {\r\n        breakpoint: 992,\r\n        settings: {\r\n          slidesToShow: 2,\r\n          slidesToScroll: 2,\r\n          arrows: true\r\n        }\r\n      },\r\n      {\r\n        breakpoint: 576,\r\n        settings: {\r\n          slidesToShow: 1.5,\r\n          slidesToScroll: 1,\r\n          arrows: true\r\n        }\r\n      }\r\n    ]\r\n  });\r\n}\r\n\r\nfunction awardsCarousel() {\r\n  var awards = jquery__WEBPACK_IMPORTED_MODULE_1___default()('.js-press__awards-carousel');\r\n  var header = awards.siblings('.press__title-header');\r\n  awards.slick({\r\n    infinite: false,\r\n    autoplaySpeed: 3000,\r\n    slidesToShow: 6,\r\n    slidesToScroll: 6,\r\n    autoplay: true,\r\n    appendArrows: header,\r\n    pauseOnHover: true,\r\n    responsive: [\r\n      {\r\n        breakpoint: 1200,\r\n        settings: {\r\n          slidesToShow: 4,\r\n          slidesToScroll: 4,\r\n          centerMode: false,\r\n          arrows: true\r\n        }\r\n      },\r\n      {\r\n        breakpoint: 992,\r\n        settings: {\r\n          slidesToShow: 3,\r\n          slidesToScroll: 3,\r\n          centerMode: false,\r\n          arrows: true\r\n        }\r\n      },\r\n      {\r\n        breakpoint: 768,\r\n        settings: {\r\n          slidesToShow: 2,\r\n          slidesToScroll: 2,\r\n          centerMode: false,\r\n          arrows: true\r\n        }\r\n      },\r\n      {\r\n        breakpoint: 576,\r\n        settings: {\r\n          slidesToShow: 1.25,\r\n          slidesToScroll: 1,\r\n          centerMode: true,\r\n          arrows: true\r\n        }\r\n      },\r\n      {\r\n        breakpoint: 450,\r\n        settings: {\r\n          slidesToShow: 1.1,\r\n          slidesToScroll: 1,\r\n          centerMode: true,\r\n          arrows: true\r\n        }\r\n      }\r\n    ]\r\n  });\r\n}\r\n\r\nfunction articlesCarousel() {\r\n  var articles = jquery__WEBPACK_IMPORTED_MODULE_1___default()('.js-press__articles-carousel');\r\n  articles.each( function() {\r\n    jquery__WEBPACK_IMPORTED_MODULE_1___default()( this ).slick( {\r\n      infinite: false,\r\n      speed: 500,\r\n      slidesToShow: 4,\r\n      slidesToScroll: 4,\r\n      draggable: false,\r\n      swipe: false,\r\n      appendArrows: jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).parents('.press__articles-section').find('.press__title-header'),\r\n      responsive: [\r\n        {\r\n          breakpoint: 1200,\r\n          settings: {\r\n            slidesToShow: 3,\r\n            slidesToScroll: 3,\r\n            arrows: true,\r\n            draggable: false,\r\n            swipe: false\r\n          }\r\n        },\r\n        {\r\n          breakpoint: 992,\r\n          settings: {\r\n            slidesToShow: 3,\r\n            slidesToScroll: 3,\r\n            arrows: true,\r\n            draggable: false,\r\n            swipe: false\r\n          }\r\n        },\r\n        {\r\n          breakpoint: 768,\r\n          settings: {\r\n            slidesToShow: 2,\r\n            slidesToScroll: 2,\r\n            arrows: true,\r\n            draggable: false,\r\n            swipe: false\r\n          }\r\n        },\r\n        {\r\n          breakpoint: 576,\r\n          settings: {\r\n            slidesToShow: 1.5,\r\n            slidesToScroll: 1,\r\n            arrows: true,\r\n            draggable: false,\r\n            swipe: false\r\n          }\r\n        },\r\n        {\r\n          breakpoint: 400,\r\n          settings: {\r\n            slidesToShow: 1.25,\r\n            slidesToScroll: 1,\r\n            arrows: true,\r\n            draggable: false,\r\n            swipe: false\r\n          }\r\n        }\r\n      ]\r\n    });\r\n  });\r\n}\r\n\r\n\r\n// mobile video carousel\r\n// related products carousel\r\nfunction mobileVideoCarousel() {\r\n  var $videoCarousel = jquery__WEBPACK_IMPORTED_MODULE_1___default()('.js-press-video-carousel');\r\n  var videoCarouselSettings = {\r\n    infinite: false,\r\n    slidesToScroll: 1,\r\n    slidesToShow: 1.25\r\n  }\r\n  // slick/unslick on window width \r\n  if($videoCarousel.hasClass('slick-initialized')) {\r\n    $videoCarousel.slick(\"unslick\");\r\n  }\r\n}\r\n\r\n// video gallery - show 6 videos initialy and then show 3 more on \"load more videos\" button\r\nfunction loadMoreVideos() {\r\n  var itemsShown = 6;\r\n  var videoList = jquery__WEBPACK_IMPORTED_MODULE_1___default()('.js-press-video-list');\r\n  var videoListItem = jquery__WEBPACK_IMPORTED_MODULE_1___default()('.js-press-video-list-item');\r\n  var showMoreBtn = jquery__WEBPACK_IMPORTED_MODULE_1___default()('.js-videos-show-more');\r\n    \r\n    videoList.each(function() {\r\n      // hide items after itemsShown on md and up\r\n      jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).find(videoListItem).slice(itemsShown).hide();\r\n    })\r\n\r\n  showMoreBtn.click(function(e){\r\n    e.preventDefault();\r\n    jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).closest(videoList).find(videoListItem).show();\r\n    jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).remove();\r\n  }); \r\n}\r\n\n\n//# sourceURL=webpack://starter-theme/./src/scripts/templates/page.press.js?");

/***/ }),

/***/ "jquery":
/*!*************************!*\
  !*** external "jQuery" ***!
  \*************************/
/***/ ((module) => {

module.exports = jQuery;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"template.page.press": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkstarter_theme"] = globalThis["webpackChunkstarter_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__("./src/scripts/templates/page.press.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;